import React, { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import ActionsRow from '../../../Components/antd/Lists/ActionsRow'
import { selectUser } from '../../../reducers/UserReducer'
import useInternship from '../../../utils/api/hooks/useInternship'
import { Action, DeleteAction, getActionsClass } from '../../../Components/antd/Tables/DataTable/utils/actions'
import { faFile } from '@fortawesome/pro-solid-svg-icons'
import { ActionTypes } from 'redux-devtools'
import { ColorsPalette } from '../../../config/colors'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import useModules from '../../../hooks/useModules'

const InternshipToolBar = ({ internships = [], onUnselect }) => {
  const { isDraft } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const internshipHandler = useInternship({ user, t })
  const modules = useModules()

  const actions = useMemo(() => {
    const actions = []

    if (modules.internshipsDraft) {
      actions.push(new Action({
        title: t('internship_toolbar.buttons.' + (isDraft ? 'publish_schedules' : 'unpublish_schedules')),
        className: getActionsClass,
        ghost: true,
        icon: faFile,
        type: ActionTypes.GLOBAL,
        color: ColorsPalette.BLUE_ICON,
        onClick: () => {
          internshipHandler.bulkDraftSchedules(internships, !isDraft).then(() => onUnselect(true))
        }
      }))
    }

    actions.push(new DeleteAction({
      title: t('internship_toolbar.buttons.delete'),
      popconfirmTitle: (
        <div style={{ maxWidth: '250px' }}>
          <b> {t('common.warning')}</b> <br />
          {t('shift_manager.warning_modal_body')}
        </div>
      ),
      ghost: true,
      onDelete: () => internshipHandler.deleteShifts(internships).then(() => onUnselect(internships))
    }))

    return actions
  }, [internshipHandler, internships, isDraft, modules, onUnselect])

  return (
    <div className='absolute left-50p z-500'>
      <ActionsRow
        actions={actions}
        buttonTitle={t('internship_toolbar.button_title', { numberOfInternships: internships.length })}
        buttonTooltipTitle={t('internship_toolbar.button_tooltip_title')}
        data={internships}
        onUnselect={onUnselect}
      />
    </div>
  )
}

export default InternshipToolBar
